<template>
  <div class="lang-select__container" :class="isMobile ? 'h5':'pc'">
    <div class="lang-select__mask" @click="hidePanel"></div>
    <div class="lang-select__panel">
    <div class="lang-select__header">
      <div class="lang-select__icon"></div>
      <div class="lang-select__title">Choose the service language</div>
    </div>
    <div class="lang-select__content">
      <div class="lang-select__select">
        <div class="webim-select">
          <select v-model='selectdLang'>
            <option v-for="item in langList" :value="item.value">{{ item.text }}</option>
          </select>
        </div>
      </div>
      <div class="lang-select__switch">
        <span class="lang-select__switch__container" @click="switchAutoTranslate">
          <div class="webim-switch"> <input class="webim-switch__input" type="checkbox">
            <div :class="['webim-switch__slider', autoTranslateSwitch ? 'webim-switch__slider--on':'']"></div>
          </div>
        </span>
        <span class="lang-select__switch__label">Auto translation</span>
      </div>
      <div class="lang-select__tip">Show translation when receiving message</div>
      <div class="lang-select__button" @click="submit">OK</div>
    </div>
  </div>
  </div>
</template>

<script>
import globalWin from '@/utils/globalWin';
export default {
  inject: ['to'],
  data() {
    return {
      isShowPanel: true,
      // 是否开启自动翻译
      autoTranslateSwitch: globalWin.translate && globalWin.translate.translateAuto,
      langList: [
        {
          text: 'English',
          value: 'en',
        },
        {
          text: '繁体中文',
          value: 'zh-TW',
        },
        {
          text: '简体中文',
          value: 'zh',
        },

      ],
      // 选中的语言
      selectdLang: '',
      // 默认选中的语言
      defaultLang: '',
    };
  },
  computed: {
    isMobile() {
      return !this.$platform.pc;
    },
  },
  mounted() {
    this.defaultLang = this.$i18n.locale || this.langList[2].value;
    this.selectdLang = this.defaultLang;
  },
  methods: {
    // 自动翻译开关切换
    switchAutoTranslate() {
      this.autoTranslateSwitch = !this.autoTranslateSwitch;
    },
    submit() {
      if (globalWin.translate) {
        globalWin.translate.translateAuto = this.autoTranslateSwitch;
      }
      // 没有切换别的语言，不请求
      if (this.selectdLang === this.defaultLang) {
        globalWin.switchSetLangPanel(false);
        return;
      }
      // 发请求
      globalWin.setLangRequest(this.selectdLang)
        .then(() => {
          // 关闭弹窗
          globalWin.switchSetLangPanel(false);
          // 发送切换语言提示消息
          globalWin.sendLangTip(true);
        })
        .catch(() => {
          this.$Toast('切换语言失败');
        });
    },
    hidePanel() {
      globalWin.switchSetLangPanel(false);
    },
  },
};
</script>

<style lang="less" scoped>
@import './style.less';
.lang-select {
  &__mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 11;
  }
  &__panel {
    position: absolute;
    width: 340px;
    height: 315px;
    box-sizing: border-box;
    padding: 30px 45px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 6px;
    border: 1px solid #dadee7;
    box-shadow: 0 1px 5px 0 rgba(30, 35, 48, 0.08);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 12;
  }

  &__header {
    text-align: center;
  }

  &__bottom {
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    color: #a8abb3;
    margin: 10px auto;
    max-width: 360px;
  }

  &__icon {
    width: 80px;
    height: 50px;
    background-size: 80px 50px;
    background-image: url(./asstes/translate-lang-icon.png);
    margin: 0 auto;
  }

  &__title {
    font-size: 17px;
    line-height: 20px;
    margin-top: 14px;
  }

  &__desc {
    font-size: 12px;
    line-height: 16px;
    color: #a8abb3;
  }

  &__content {
    text-align: center;
    margin-top: 20px;
  }

  &__switch {
    display: flex;
    align-items: center;

    &__container {
      font-size: 0;
    }

    &__label {
      margin-left: 10px;
      color: #66686c;
      line-height: 20px;
      font-size: 14px;
    }
  }

  &__tip {
    color: #a8abb3;
    font-size: 12px;
    line-height: 16px;
    margin: 6px 0 14px 0;
    text-align: left;
  }

  &__select {
    margin-bottom: 16px;

    select {
      display: block;
      width: 100%;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border: 1px solid #dadee7;
      outline: 0;
      background-color: transparent;
      height: 40px;
      line-height: 38px;
      font-size: 14px;
      padding: 0 10px 0 12px
    }
  }

  &__button {
    display: block;
    border-radius: 3px;
    color: #fff;
    text-align: center;
    border: 1px solid #4A70FF;
    background-color: #4A70FF;
    width: 100%;
    height: 40px;
    line-height: 38px;
    font-size: 16px;

    &.pending {
      position: relative;
      pointer-events: none;
      text-indent: -9999px;

      &::after {
        position: absolute;
        left: 50%;
        top: 50%;
        display: block;
        width: 18px;
        height: 18px;
        margin: -9px 0 0 -9px;
        content: '';
        background-size: 18px 18px;
        // eslint-disable-next-line max-len
        background:url(@bg);
      }
    }

    &.disabled {
      opacity: .38;
      filter: alpha(opacity=38);
      pointer-events: none;
    }
  }
}

.webim-switch {
    display: inline-block;
    position: relative;
    width: 36px;
    height: 20px;

    &__input {
        display: none;
    }

    &__slider {
        position: absolute;
        cursor: pointer;
        transition: .4s;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border-radius: 10px;
        background-color: #a8abb3;

        &::before {
            position: absolute;
            cursor: pointer;
            transition: .4s;
            display: block;
            content: '';
            width: 16px;
            height: 16px;
            left: 2px;
            bottom: 2px;
            border-radius: 8px;
            background-color: #fff;
        }

        &--on {
            background-color: #00cc26;

            &::before {
                transform: translateX(16px);
            }
        }
    }
}

.h5 {
  .lang-select__panel {
        width: 85%;
        max-width: 320px;
        height: 315px;
        box-sizing: border-box;
        padding: 25px 40px;
        margin: 0 auto;
        background-color: #fff;
        border-radius: 6px;
        border: 1px solid #dadee7;
        box-shadow: 0 1px 5px 0 rgba(30, 35, 48, 0.08);
    }
}
</style>
